import { Skeleton } from 'components/ui/skeleton'
import * as T from 'components/ui/typography'

interface PropsTitleSection {
    title: string
    subtitle: string
    pt?: string
    loading?: boolean
}

export const TitleSection = (props: PropsTitleSection) => {
    return (
        <div className={`${props.pt ? `pt-[${props.pt}` : 'pt-[30px]'} pb-6`}>
            {props.loading ? (
                <>
                    <Skeleton className="w-[30vw] mb-2" />
                    <Skeleton className="w-[25vw]" />
                </>
            ) : (
                <>
                    <T.H2 className="font-[Manrope] text-primary font-semibold text-2xl py-1">{props.title}</T.H2>
                    <T.Muted className="text-neutral-400">{props.subtitle}</T.Muted>
                </>
            )}
        </div>
    )
}
